

import moment from 'moment';
import {computed, onMounted, ref} from 'vue'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import {ListCustomer} from "@/models/listCustomer";
import zaloRepository from "@/services/ZaloRepository";
import {FilterMatchMode} from "primevue/api";
import {ManagerCheckinCreate} from "@/models/managerCheckinCreate";
import {ManagerCheckin} from "@/models/managerCheckin";
import {Ds_Cls} from "@/models/ds_Cls";
import {FileDetail} from "@/models/fileDetail.models";
import axios from "axios";
import {Cls} from "@/models/cls";
import {ClsUpdate} from "@/models/clsUpdate";
import ZaloRepository from "@/services/ZaloRepository";
import {SendClsForCus} from "@/models/sendClsForCus";
import {ListIdCls} from "@/models/listIdCls";

export default {

  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const maYTe = ref("");
    const listCLS = ref([] as Ds_Cls[]);
    const listFileCls = ref([] as Cls[]);
    const ngaySinh = ref("")
    const permissionCLS = ref(false);
    const cls = ref({} as ClsUpdate);
    const listClsSent = ref([] as Cls[]);
    const date = ref();
    const listIdCls = ref();
    listIdCls.value = [];
    const sendingData = ref(false);

    if((store.state.permission == 'cls')){
      permissionCLS.value = true;
    }

    const loadListCls = () => {
      console.log("#####$$$$$$$$$$ loadListCls: " );
      loadingData.value = true;
      zaloRepository.getDanhSachCls(maYTe.value)
          .then((response) => {
            console.log("#####$$$$$$$$$$ loadListCls 0000000: " );
            listCLS.value = response.data;
            listIdCls.value = []
            cls.value.kind = "";
            listFileName.value = [];
            console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(listCLS.value));
            console.log("#####$$$$$$$$$$ listCLS.value.length: " + listCLS.value.length);
            if(listCLS.value.length > 0) {
              if (listCLS.value[0].ngaysinh != null) {
                ngaySinh.value = formatDate(listCLS.value[0].ngaysinh);
              }
            }
            console.log("#####$$$$$$$$$$ listCLS.value.length aaaa: ");

            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  loadingData.value = false;
                  console.log("#####$$$$$$$$$$ getListCLS: " + JSON.stringify(response.data));
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                   x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  loadingData.value = false;
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          })
          .catch(err => {
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatDateTime = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm:ss DD/MM/YYYY');
    };

    const formatDate = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('DD/MM/YYYY');
    };
    const listLink = ref([] as string[]);
    let listFileName = ref([] as FileDetail[]);
    const loadingBar = ref(false);
    const upload = () => {
      {
        // listCLS.value[0].sodienthoai = "0905333122"; // debug
        // listCLS.value[0].sodienthoai = "0905123456"; // debug
        listLink.value = [];
        var files = new FormData();
        listFileName.value.forEach(x =>
        {
          files.append("formFiles", x.value, x.nameFile);
        });
        loadingBar.value = true;
        loadingData.value = true;
        axios.defaults.headers.common = {'Authorization': `Bearer ${store.state.token}`}
        axios.post(`../api/File/UploadFileCLS/${listCLS.value[0].sodienthoai}/${maYTe.value}`, files,
        // axios.post(`../api/File/UploadFileCLS/0905333122/${maYTe.value}`, files,
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
              }
            }).then(response => {
          loadingData.value = false;
          loadingBar.value = false;
          listFileName.value = [];
          if(response.data.status) {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Tải kết quả thành công',
              life: 2000
            });
            cls.value.id = response.data.idCls;
            cls.value.patientsName = listCLS.value[0].tenbenhnhan;
            zaloRepository.updateCLS(cls.value)
                .then((response) => {
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });

            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          }
          else{
            toast.add({
              severity: 'warn',
              summary: 'Lỗi',
              detail:response.data.log,
              life: 2500
            });
          }
        })
            .catch(err => {
              loadingData.value = false;
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })});
      }
    };

    const fileChange = (fileList) => {
      var leng = fileList.length;
      for (var i = 0; i < leng; i++)
      {
        var filetemp = ref({} as FileDetail);
        filetemp.value.nameFile = fileList[i].name;
        filetemp.value.value = fileList[i];
        listFileName.value.push(filetemp.value);
      }
    };

    // const sendFileResult = (id: number) => {
    //   console.log("#####$$$$$$$$$$ sendResult: " );
    //   zaloRepository.sendResult(id)
    //       .then((response) => {
    //         zaloRepository.getListCLS(maYTe.value)
    //             .then((response) => {
    //               listFileCls.value = response.data;
    //
    //               listFileCls.value.forEach(x =>{
    //                 x.path =  x.path.split("/")[3];
    //               })
    //             })
    //             .catch(err => {
    //               toast.add({
    //                 severity: 'error',
    //                 summary: 'Lỗi',
    //                 detail: err.response.data,
    //                 life: 2000
    //               });
    //             });
    //       })
    //       .catch(err => {
    //         console.log("#####$$$$$$$$$$ sendFileResult 1111111: " );
    //         console.log("#####$$$$$$$$$$ sendFileResult 1111111aaa : " + JSON.stringify(err.response));
    //         console.log("#####$$$$$$$$$$ sendFileResult 1111111bbb : " + JSON.stringify(err.response.data));
    //         // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
    //         toast.add({
    //           severity: 'error',
    //           summary: 'Lỗi',
    //           detail:'Lỗi khi tải dữ liệu',
    //           life: 2000
    //         });
    //       });
    // }

    const loadingData = ref(false);

    const selectCalendar = () => {
      if((date.value[0] != null)&&(date.value[1] != null))
      {
        loadingData.value = true;
        listClsSent.value = [];
        ZaloRepository.getListCls(date.value[0]/1000, date.value[1]/1000)
            .then((response) => {
              loadingData.value = false;
              listClsSent.value = response.data;
              listClsSent.value.forEach(x => {
                if(x.timeSend != null)
                {
                  x.time = x.timeSend;
                }
              })
            })
            .catch(err => {
              loadingData.value = false;
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };

    // selectCalendar();

    const clearCalendar = () => {
      listClsSent.value = [];
    }
    const downloadFile = ref(false);
    const fileName = ref("");
    const loadingExport = ref(false);
    const exportFile = () => {
      loadingData.value = true;
      loadingExport.value = true;
      downloadFile.value = false;
      zaloRepository.exportClsFile(listClsSent.value)
          .then((response) => {
            loadingData.value = false
            fileName.value = response.data;
            toast.add({
              severity: 'success',
              summary: 'Xuất dữ liệu',
              detail: 'Xuất dữ liệu thành công',
              life: 2000
            });
            loadingExport.value = false;
            downloadFile.value = true;
          })
          .catch(err => {
            loadingData.value = false;
            loadingBar.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const downLoadFileExport = (file) => {
      axios({
        url: '../api/webhook/downloadListCheckIn/' + file,
        method: 'GET',
        responseType: 'blob',
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
            const link = document.createElement('a');
            link.href = url;
              link.setAttribute('download', "DanhSachGoiKetquaCLS" + ".xlsx");
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    };

    const selectCheckBox = () => {
      console.log("############### debug checkbox listIdCls: " + listIdCls.value);
    }

    const sendClsForCustomer = () => {
      // console.log("############### debug checkbox listIdCls: " + JSON.stringify(listIdCls.value));
      // console.log("############### debug checkbox listIdCls.value.split(','): " + JSON.stringify(listIdCls.value.split(',')));
      // const str = listIdCls.value.split(',');
      const sendCls = ref({} as SendClsForCus);
      const listId = ref([] as ListIdCls[]);
      //const listCls = ref([] as )
      listIdCls.value.forEach( x =>{
            console.log("############### debug checkbox x: " + x);
            const b = ref({} as ListIdCls);
            b.value.idCls = x;
            listId.value.push(b.value);
      }
      );
      sendingData.value = true;
      sendCls.value.listCls = listId.value;
      console.log("############### debug checkbox sendCls: " + JSON.stringify(sendCls.value));
      zaloRepository.sendResult(sendCls.value)
          .then((response) => {
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  toast.add({
                    severity: 'success',
                    summary: 'Thành công',
                    detail: 'Gởi kết quả thành công cho bệnh nhân',
                    life: 3000
                  });
                  sendingData.value = false;
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  sendingData.value = false;
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          })
          .catch(err => {
            console.log("#####$$$$$$$$$$ sendFileResult 1111111: " );
            console.log("#####$$$$$$$$$$ sendFileResult 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ sendFileResult 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    const ipAddress = ref("Đang lấy...");

    onMounted(async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        ipAddress.value = data.ip;
        console.log("#####$$$$$$$$$$ sendFileResult ipAddress.value : " + ipAddress.value );
      } catch (err) {
        ipAddress.value = "Không lấy được IP";
        console.error(err);
      }
    });

    return {
      error,
      filters,
      clearFilter,
      initFilters,
      maYTe,
      formatDateTime,
      listCLS,
      loadListCls,
      ngaySinh,
      upload,
      listLink,
      listFileName,
      loadingBar,
      fileChange,
      listFileCls,
      permissionCLS,
      cls,
      selectCalendar,
      date,
      clearCalendar,
      listClsSent,
      exportFile,
      downLoadFileExport,
      downloadFile,
      fileName,
      loadingData,
      listIdCls,
      selectCheckBox,
      sendClsForCustomer,
      sendingData
    }
  }
}

